import cn from "classnames";

import {
  ButtonLink,
  ButtonTheme,
} from "@/components/buttonLink/buttonLink.component";
import type { ContainerBuilderBlock } from "@/components/containerBuilder/containerBuilder.component";

import { resolveCtaLink } from "@/utils/url.util";

/**
 * Page builder block for a standalone call to action, supporting both link and phone CTAs.
 *
 * Button styling is owned by `ButtonLink`;
 */
export function ButtonBuilder({ block }: ButtonBuilderProps) {
  const resolved = block ? resolveCtaLink(block) : null;

  if (!resolved) return null;
  const alignment = block.alignment ?? "left";

  return (
    <section
      data-testid="button-builder"
      className={cn("flex", {
        "justify-start": alignment === "left",
        "justify-center": alignment === "center",
        "justify-end": alignment === "right",
      })}>
      <ButtonLink {...resolved} theme={block.theme as ButtonTheme} />
    </section>
  );
}

type ContainerChild = NonNullable<ContainerBuilderBlock["children"]>[number];

export type ButtonBuilderBlock = Extract<
  ContainerChild,
  { _type: "buttonBuilder" }
>;

type ButtonBuilderProps = {
  block: ButtonBuilderBlock;
};
